module.exports = __webpack_public_path__ + "static/coinbtltd-complete-4919541f12cc560bab5e5b95b6761147.jpg";